export default (list, propertyKey, value) => list.find(listItem => listItem[propertyKey] === value);
